import React, { useRef, useState } from 'react';

import { findClosestScrollParentY } from '../../../../../helpers/findClosestScrollParentY';

import TabCard from '../TabCard/TabCard';
import ErrorMessage from '../../../../../design-system/ErrorMessage/ErrorMessage';
import TabEditorModal from '../TabEditorModal/TabEditorModal';
import TabTypesSelector from '../TabTypesSelector/TabTypesSelector';

const TabSettingsSection = ({ formData, setTabs, playbookId, fieldErrorMessages }) => {
    const tabs = formData.view_content?.tabs;

    const buttonRef = useRef(null);

    const [addTabModal, setAddTabModal] = useState({ type: null });
    const [tabTypeSelector, setTabTypeSelector] = useState(null);

    const errorMessage = fieldErrorMessages.view_content;

    const openSelector = () => {
        try {
            let scrollParent = findClosestScrollParentY(buttonRef.current);

            if (buttonRef && scrollParent) {
                const buttonEl = buttonRef.current;

                const buttonRect = buttonEl.getBoundingClientRect();
                const scrollParentRect = scrollParent.getBoundingClientRect();

                const distanceToBottom = scrollParentRect.bottom - buttonRect.bottom;

                if (distanceToBottom < 152) {
                    setTabTypeSelector({ positioned: 'up' });
                    return;
                }
            }
            setTabTypeSelector({ positioned: 'down' });
        } catch (e) {
            setTabTypeSelector({ positioned: 'down' });
        }
    };

    const areTabs = !!tabs?.length;

    return (
        <div className="flex flex-col gap-5">
            <h3 className="font-body-bold text-body-bold-m text-black">Tab Settings</h3>

            <div className="flex flex-col gap-2">
                {areTabs && (
                    <ul className="flex flex-col gap-2">
                        {tabs?.map((tab) => (
                            <TabCard
                                key={tab.order}
                                tab={tab}
                                setTabs={setTabs}
                                playbookId={playbookId}
                            />
                        ))}
                    </ul>
                )}

                {!areTabs && (
                    <p className="font-body-bold text-body-bold-xs text-neutral-500">
                        Click “Add New” to add a tab
                    </p>
                )}

                {errorMessage && <ErrorMessage message={errorMessage} />}
            </div>

            <div className="flex justify-end relative">
                <button
                    ref={buttonRef}
                    onClick={openSelector}
                    className="py-1.5 font-heading-bold text-[14px] font-semibold text-neutral-400 whitespace-nowrap underline underline-offset-2"
                >
                    Add New
                </button>

                {tabTypeSelector && (
                    <TabTypesSelector
                        positioned={tabTypeSelector.positioned}
                        handleSelect={(type) => setAddTabModal({ type })}
                        onClose={() => setTabTypeSelector(null)}
                    />
                )}
            </div>

            {addTabModal?.type && (
                <TabEditorModal
                    mode="create"
                    type={addTabModal.type}
                    playbookId={playbookId}
                    setTabs={setTabs}
                    onClose={() => setAddTabModal({ type: null })}
                />
            )}
        </div>
    );
};

export default TabSettingsSection;
